import * as moment from "moment"
import * as _ from "lodash"
import { camelize, snakeize, humanize } from './helpers'

_.mixin({
  camelize: camelize,
  snakeize: snakeize,
  humanize: humanize,

  // Modified binary search, which uses the result of the compare function
  // on the index rather than just the given arrays index result to get the
  // closest value to the target
  binarySearch: function(values: any[], compare: (any) => number) {
    let low = 0
    let mid
    let high = values.length - 1
    while (low <= high) {
      mid  = Math.floor((low + high) / 2)
      // we found the correct index
      if (compare(values[mid]) == 0) {
        return values[mid]
      } else if (compare(values[mid]) > 0) {
        // it is on the right side
        // if the next value right of the current mid index would be further away than the current value, use the current value
        if (mid < high && Math.abs(compare(values[mid])) < Math.abs(compare(values[mid + 1]))  ) {
          return values[mid];
        }
        low = mid + 1
      } else {
        // if the next value left of the current mid index would be further away than the current value, use the current value
        if (mid > 0 && Math.abs(compare(values[mid])) < Math.abs(compare(values[mid - 1]))  ) {
          return values[mid];
        }
        // it is on the left side
        high = mid - 1
      }
    }
    return values[mid]
  },

  toAge: function(dateOfBirth, date) {
    let dob = moment(dateOfBirth)
    let now = null
    if (date != null) {
      now = moment(date)
    } else {
      now = moment()
    }
    let years = now.year() - dob.year()
    if (now.month() < dob.month())
      years -= 1
    if (now.month() === dob.month() && now.day < dob.day())
      years -= 1
    return years
  },

  diffKeys: function(objectA: any, objectB: any): string[] {
    return _.reduce(objectA, function(result, value, key) {
      if (_.isEqual(value, objectB[key])) {
        return result
      } else {
        return result.concat(key)
      }
    }, [])
  },

  uniformSubset: function<T>(array: T[], count): any {
    let indicies = _.range(0, array.length, array.length / count)
    return _.map(indicies, function(i) {
      return array[Math.round(i)]
    })
  }
});
